exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .progress {\r\n  height: auto !important;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  -webkit-box-shadow: none;\r\n} */\r\n\r\n/* .progress .progress-bar {\r\n    background-color: #cecece;\r\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/progressBar/progressbar.component.css
// module id = ../../../../../src/app/helpers/components/progressBar/progressbar.component.css
// module chunks = main